export { default } from "./TranslationTextArea";
